import 'expose-loader?videojs!video.js';
import 'videojs-contrib-ads/src/videojs.ads';
import 'videojs-ima';
import 'videojs-ga/dist/videojs.ga.js';
import 'videojs-social';
import 'videojs-download-button';



// WEBPACK FOOTER //
// ./src/bundle.js